<template>
  <div
    class="border-1 rounded-xl shadow-md h-full flex flex-col-reverse py-10 md:py-0"
    :class="{
      'md:grid md:grid-cols-12': position > 1,
      'bg-white': position < 3,
      'md:col-span-2': position === 2,
      'bg-white md:bg-indigo-200 md:col-span-1 md:row-span-2': position === 3,
    }"
  >
    <!-- Button add + illustration -->
    <div
      class="relative flex flex-col items-center mt-10"
      :class="{
        'col-span-full md:self-center': position !== 2,
        'md:mt-0 md:pb-0': position > 1,
        'md:my-10 md:space-y-5': position === 1,
        'col-span-7 md:self-end': position === 2,
        'md:space-y-0 xl:space-y-5': position === 3,
      }"
    >
      <illustration
        v-if="position > 1"
        name="Group189"
        class="hidden md:block"
        :class="{
          'absolute left-0 bottom-3 md:bottom-18 xl:bottom-32 lg:left-10 xl:left-3 xxl:left-14 2xl:left-28':
            canAddBeneficiary && position === 2,
          'md:transform md:scale-80 lg:scale-85 xl:scale-100 xxl:scale-110 2xl:scale-x-125':
            position === 2,
          'md:transform md:scale-75 xl:scale-85 xxl:scale-95 2xl:scale-x-100':
            position === 3,
        }"
      />
      <div :class="{ 'mb-10': position === 2 }">
        <action-button
          id="add-neopass"
          class="z-10"
          v-if="$can(constants.PERMISSION_NEOPASS_AJOUTER_BENEFICIAIRE)"
          border-color="border-transparent"
          text-color="text-white"
          bg-color="bg-pink-600"
          bg-color-square="bg-pink-600"
          icon-color="text-white"
          libelle="AJOUTER UN CARNET"
          :uppercase="true"
          icon="plus-circle"
          :right="true"
          :responsive="false"
          type-shadow="shadow-pink"
          @clickAction="displayAddNeopassPopup"
        />
        <router-link
          v-else-if="isBeneficiary"
          class="z-10"
          :to="'/form/neopass/' + user.id"
        >
          <action-button
            class="text-2sm"
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-pink-600"
            bg-color-square="bg-pink-600"
            icon-color="text-white"
            libelle="EDITER MON CARNET"
            :uppercase="true"
            icon="arrow-right_1"
            :right="true"
            :responsive="false"
            type-shadow="shadow-pink"
            :enable-action="false"
          />
        </router-link>
      </div>
    </div>
    <!-- Liste Neopass -->
    <div
      class="bg-white flex flex-col space-y-4"
      :class="{
        'col-span-full w-full justify-start h-full md:mt-5': position === 1,
        'col-span-5 self-center w-full md:pr-5': position === 2,
        'col-span-full md:py-5 md:m-2 md:rounded-xl md:shadow-lg':
          position === 3,
        'md:px-5': position !== 2,
      }"
    >
      <div
        id="neopass-list"
        class="text-2xl md:text-xl xl:text-2xl font-normal w-full text-center md:text-left"
      >
        Carnet{{ isBeneficiary ? '' : 's' }}
        de parcours
      </div>
      <!-- BEGIN List module for Beneficiary -->
      <div
        v-if="isBeneficiary"
        class="overflow-y-auto hide-scroll-bar h-60 md:h-40 xl:h-56"
      >
        <div
          v-for="(mod, i) in listModules.filter(
            (m) =>
              permissions.includes(m.name + '_read') ||
              permissions.includes(m.name + '_edit')
          )"
          :key="i"
          class="odd:bg-indigo-100 odd:bg-opacity-50 grid grid-cols-12 gap-2 items-center p-4 md:py-2.5 md:px-2.5 xl:p-3"
        >
          <div class="text-base-0 text-gray-600 font-normal col-span-10 w-full">
            {{ mod.display_name }}
          </div>
          <div class="col-span-2" title="Editer ce module">
            <router-link
              v-if="$can(constants.PERMISSION_NEOPASS_FORM_PAGE)"
              class="text-indigo-600 rounded-full bg-pink-100 p-1 h-8 w-8 md:h-6 md:w-6 xl:w-8 xl:h-8 flex justify-center items-center"
              :to="'/form/neopass/' + user.id + '/' + mod.name"
            >
              <icon
                name="edit"
                class="md:h-2 md:w-2 xl:w-3 xl:h-3 text-indigo-600"
                :label="'Editer le module ' + mod.display_name"
              />
            </router-link>
            <span
              v-else
              class="text-indigo-600 rounded-full bg-pink-100 p-1 h-8 w-8 md:h-6 md:w-6 xl:w-8 xl:h-8 flex justify-center items-center"
            >
              <icon
                name="edit"
                class="md:h-2 md:w-2 xl:w-3 xl:h-3 text-indigo-600"
                :label="'Editer le module ' + mod.display_name"
              />
            </span>
          </div>
        </div>
      </div>
      <!-- END List module for Beneficiary -->

      <!-- BEGIN List Neopass for admin/referent -->
      <div v-else>
        <div
          v-if="listNeopass != null && listNeopass.length > 0"
          id="neopass-list-dashboard"
          class="overflow-y-auto hide-scroll-bar"
          :class="{
            'h-60 md:h-40 xl:h-56': position > 1,
            'h-60 md:h-20 xl:h-40': position === 1 && buttonDisplayed,
          }"
        >
          <div
            v-for="(neopass, i) in listNeopass"
            :key="i"
            class="odd:bg-indigo-100 odd:bg-opacity-50 grid grid-cols-12 gap-2 items-center p-4 md:p-2.5 xl:p-3"
            :id="'neopass-' + i"
          >
            <div class="w-full col-span-3 md:col-span-2 xl:col-span-3">
              <div class="flex items-center justify-start">
                <profile-picture
                  class="md:hidden xl:block"
                  size="max-w-8 w-8 h-8"
                  :other-object="neopass"
                />
                <profile-picture
                  class="hidden md:block xl:hidden"
                  size="max-w-6 w-6 h-6"
                  :other-object="neopass"
                />
              </div>
            </div>

            <div
              class="text-gray-600 font-normal text-base-0 col-span-7 md:col-span-8 xl:col-span-7"
            >
              {{ neopass.firstname }}
              <span class="uppercase">{{ neopass.lastname }}</span>
            </div>

            <div class="col-span-2" title="Modifier le carnet">
              <router-link
                v-if="$can(constants.PERMISSION_NEOPASS_FORM_PAGE)"
                class="text-indigo-600 rounded-full bg-pink-100 p-1 h-8 w-8 md:h-6 md:w-6 xl:w-8 xl:h-8 flex justify-center items-center"
                :to="'/form/neopass/' + neopass.id"
              >
                <icon
                  name="edit"
                  class="md:h-2 md:w-2 xl:w-3 xl:h-3 text-indigo-600"
                  label="Modifier le carnet"
                />
              </router-link>
              <span
                v-else
                class="text-indigo-600 rounded-full bg-pink-100 w-8 h-8 flex justify-center items-center"
              >
                <icon
                  name="edit"
                  class="md:h-2 md:w-2 xl:w-3 xl:h-3 text-gray-600"
                  label="Modifier le carnet"
                />
              </span>
            </div>
          </div>
        </div>
        <div
          v-else
          class="text-gray-600 text-center flex items-center justify-center h-60 md:h-40 xl:h-56"
          :class="{ 'animate-pulse': listNeopass == null }"
        >
          {{
            listNeopass == null
              ? 'En cours de chargement...'
              : "Vous n'avez pas de carnet de parcours attribué"
          }}
        </div>
      </div>
      <!-- END List Neopass for admin/referent -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ActionButton from './../ActionButton';
import Illustration from './../Illustration';
import Icon from './../Icon';
import ProfilePicture from '../../components/ProfilePicture.vue';
import Constants from '../../constants';

export default {
  props: {
    listNeopass: {
      type: Array,
      required: false,
      default: [],
    },
    position: {
      //1 : Carré / 2: Rectangle horizontal / 3: Rectangle vertical
      type: Number,
      default: 1,
    },
  },

  components: {
    ActionButton,
    Illustration,
    Icon,
    ProfilePicture,
  },

  data() {
    return {
      constants: Constants,
    };
  },

  methods: {
    displayAddNeopassPopup() {
      this.$emit('displayAddNeopassPopup');
    },
  },

  computed: {
    ...mapGetters({
      listModules: 'template/listModulesPages',
      role: 'auth/role',
      permissions: 'auth/permissions',
      user: 'auth/user',
    }),

    isBeneficiary() {
      return (
        this.role == Constants.ROLE_BENEFICIAIRE || this.user.is_particulier
      );
    },

    canAddBeneficiary() {
      return (
        this.$can(Constants.PERMISSION_NEOPASS_AJOUTER_BENEFICIAIRE) ||
        this.isBeneficiary
      );
    },

    buttonDisplayed() {
      return (
        this.$can(Constants.PERMISSION_NEOPASS_AJOUTER_BENEFICIAIRE) ||
        this.isBeneficiary
      );
    },
  },
};
</script>
